import qs from 'qs';

const axios = window.axios = require('axios');
var app = import('./app');

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.common['Tenant-Host'] = window.location.hostname;

axios.post('/tenant')
  .then(res => res.data)
  .then(tenant => {


    if (!tenant || !tenant.slug) {
      throw true;
    }

    app.then((module) => {
      module.default(tenant);
    });

  })
  .catch(error => {


    alert('Empresa não encontrada');
    // window.location = 'https://boxit.com.br'; 
  })